import { pickOrganizations } from "../rewards/pickOrganizations.js";
import { finishNode } from "../run/finishNode.js";
import type { GameState, NodeId } from "../types/index.js";
import { appendLog } from "../run/log.js";
import { accept } from "./reject.js";

export function openRelicNode(state: GameState, nodeId: NodeId): GameState {
  if (!state.run) return state;

  const pick = pickOrganizations({
    owned: state.run.organizations,
    rngState: state.run.rngState,
    stageId: state.run.stageId,
  });

  if (pick.organizationIds.length === 0) {
    const run = appendLog(
      { ...state.run, rngState: pick.rngState },
      { phase: 0, kind: "system", message: "これ以上得られる組織基盤はない" },
    );
    return accept({ ...state, screen: "map", run: finishNode(run, nodeId), resolution: null });
  }

  const run = appendLog(
    {
      ...state.run,
      currentNodeId: nodeId,
      rngState: pick.rngState,
      organizationChoices: pick.organizationIds,
    },
    { phase: 0, kind: "system", message: "組織基盤の候補が提示された" },
  );
  return accept({ ...state, screen: "reward.organization", run, resolution: null });
}
